<template>
    <div class="base-light-box">
        <slot name="image" />

        <a
            v-if="allowImageEnlargement"
            class="base-light-box__button"
            target="_blank"
            rel="noopener"
            aria-label="Click to enlarge"
            title="Click to enlarge"
            @click="handleEnlarge"
        >
            <BaseIcon icon="fullscreen" />
            Enlarge image
        </a>

        <BaseModal
            v-if="allowImageEnlargement"
            :is-visible="openModal"
            :data-large="true"
            @close="openModal = false"
        >
            <BaseFigure
                :src="image[0].intermediateUrl"
                responsive
                :srcset="getSrcSet(image[0], 'responsive')"
                width="1440"
                sizes="100vw"
                :alt="image[0].alt || ''"
            >
                <template #caption>{{ caption }}</template>
            </BaseFigure>
        </BaseModal>
    </div>
</template>

<script setup>
import useSrcSets from '~/utils/srcset';

const props = defineProps({
    allowImageEnlargement: {
        type: Boolean,
        default: false
    },
    caption: {
        type: String,
        default: null,
        required: false
    },
    image: {
        type: Array,
        default: null,
        required: true
    }
});

const openModal = ref(false);

const { getSrcSet } = useSrcSets();

const handleEnlarge = () => {
    const { trackEvent } = useCustomGtmEvent();

    trackEvent({
        event: 'open_lightbox',
        'image_url': props.image?.[0]?.intermediateUrl || null
    });

    openModal.value = true;
};
</script>

<style lang="less">
.base-light-box a {
    text-decoration: none;
}

.base-light-box__button {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: .5rem;
    cursor: pointer;
    color: inherit;


    .dn-icon svg  {
        font-size: 1.25rem;

        path {
            stroke: none;
            fill: currentColor;
        }
    }
}
</style>